import React, { useEffect } from "react";
import Header from "../../components/Header/Header";
import styles from "./BlogDetailWithFormPage.module.scss";

const BlogDetailWithFormPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.blogDetailWrapper}>
      <Header />
      <div className={styles.textContainer}>
        <img src="/images/blog2.png" alt="Blog Illustration" className={styles.illustration} />
        <h2 className={styles.heading}>Kariyerinizden Memnun Musunuz?</h2>
        <div className={styles.textSection}>
          <p className={styles.paragraph}>
            Just like graphic design and web development, UX design trends come and go for a reason. UX is all about developing a better digital world for humanity. It's a field
            that requires innovation, but that is constantly evolving. Regularly following UX design blogs can help you keep on top of changes in the industry, as well as develop
            your UX .
          </p>
          <p className={styles.paragraph}>
            Additionally, many UX design blogs expose you to case studies detailing an app or web's successful development, along with how its usability was improved. Reading about
            these types of cases can help give you ideas. In this sense, UX design blogs can help provide an indication for the kinds of directions your future projects should
            take.
          </p>
          <p className={styles.paragraph}>
            Additionally, many UX design blogs expose you to case studies detailing an app or web's successful development, along with how its usability was improved. Reading about
            these types of cases can help give you ideas. In this sense, UX design blogs can help provide an indication for the kinds of directions your future projects should
            take.
          </p>
        </div>
        <h3 className={styles.subheading}>Kariyer</h3>
        <div className={styles.textSection}>
          <p className={styles.paragraph}>
            Just like graphic design and web development, UX design trends come and go for a reason. UX is all about developing a better digital world for humanity. It's a field
            that requires innovation, but that is constantly evolving. Regularly following UX design blogs can help you keep on top of changes in the industry, as well as develop
            your UX skills.
          </p>
          <p className={styles.paragraph}>
            Additionally, many UX design blogs expose you to case studies detailing an app or web's successful development, along with how its usability was improved. Reading about
            these types of cases can help give you ideas. In this sense, UX design blogs can help provide an indication for the kinds of directions your future projects should
            take.
          </p>
          <p className={styles.paragraph}>
            Additionally, many UX design blogs expose you to case studies detailing an app or web's successful development, along with how its usability was improved. Reading about
            these types of cases can help give you ideas. In this sense, UX design blogs can help provide an indication for the kinds of directions your future projects should
            take.
          </p>
        </div>
      </div>
      <div className={styles.formWrapper}>
        <h2 className={styles.formTitle}>Raporu indirin</h2>
        <form className={styles.form}>
          <div className={styles.formRow}>
            <div className={styles.formCol}>
              <label className={styles.label}>İsim</label>
              <input type="text" placeholder="İsminiz" className={styles.input} />
            </div>
            <div className={styles.formCol}>
              <label className={styles.label}>Soy İsim</label>
              <input type="text" placeholder="Soy İsminiz" className={styles.input} />
            </div>
          </div>
          <div className={styles.formCol}>
            <label className={styles.label}>Email</label>
            <input type="email" placeholder="you@company.com" className={styles.input} />
          </div>
          <div className={styles.formCol}>
            <label className={styles.label}>Telefon Numarası</label>
            <input type="text" placeholder="TR +90(555) 000-0000" className={styles.input} />
          </div>
          <div className={styles.formCol}>
            <label className={styles.label}>Şirket İsmi</label>
            <input type="text" placeholder="Şirket İsmi" className={styles.input} />
          </div>
          <div className={styles.formCol}>
            <label className={styles.label}>Unvan</label>
            <input type="text" placeholder="Unvan" className={styles.input} />
          </div>
          <button type="submit" className={styles.button}>
            İndir
          </button>
        </form>
      </div>
    </div>
  );
};

export default BlogDetailWithFormPage;
